@if (cc.draftRuleInfo | async; as draftRuleInfo) {
  @if (cc.publishedRuleInfo | async; as publishedRuleInfo) {
    @if (draftRuleInfo.aidYear && publishedRuleInfo.aidYear) {
      @if (hasUnpublishedChanges(draftRuleInfo, publishedRuleInfo)) {
        <div class="publish-container">
          <div class="action-row">
            <button mat-flat-button color="primary" (click)="publishRules()" [disabled]="!hasUnpublishedChanges(draftRuleInfo, publishedRuleInfo)">
              {{ "Publish " + draftRuleInfo.aidYear + " Rules" }}
            </button>
            <button mat-flat-button color="warn" (click)="resetRules()">Reset Draft Rules</button>
          </div>
          <div class="info-group">
            <div class="info-row">
              <span class="info-label">Draft Rules [{{ draftRuleInfo.aidYear }}]</span>
              <span class="info-date">Last Modified {{ draftRuleInfo.lastUpdated | date: "short" }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">Published Rules [{{ publishedRuleInfo.aidYear }}]</span>
              <span class="info-date">Last Published {{ publishedRuleInfo.publishedDate | date: "short" }}</span>
            </div>
          </div>
        </div>
      } @else {
        <div>All changes have been published for aid year {{ publishedRuleInfo.aidYear }} on {{ publishedRuleInfo.publishedDate | date: "short" }}</div>
      }
    }
  }
}
